// Radio dispatch audio: Web Speech for voice + Web Audio for static bursts and beeps.
let ctx = null;
let enabled = false;

function audioCtx() {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

export function setRadioEnabled(on) {
  enabled = on;
  if (on) audioCtx();
}

function staticBurst(dur = 0.28, gain = 0.05) {
  const ac = audioCtx();
  const len = Math.floor(ac.sampleRate * dur);
  const buf = ac.createBuffer(1, len, ac.sampleRate);
  const data = buf.getChannelData(0);
  for (let i = 0; i < len; i++) data[i] = (Math.random() * 2 - 1) * 0.6;
  const src = ac.createBufferSource();
  src.buffer = buf;
  const filter = ac.createBiquadFilter();
  filter.type = "lowpass";
  filter.frequency.value = 1800;
  const g = ac.createGain();
  g.gain.setValueAtTime(gain, ac.currentTime);
  g.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + dur);
  src.connect(filter).connect(g).connect(ac.destination);
  src.start();
}

function beep(freq = 1400, dur = 0.09) {
  const ac = audioCtx();
  const osc = ac.createOscillator();
  osc.type = "square";
  osc.frequency.value = freq;
  const g = ac.createGain();
  g.gain.setValueAtTime(0.04, ac.currentTime);
  g.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + dur);
  osc.connect(g).connect(ac.destination);
  osc.start();
  osc.stop(ac.currentTime + dur);
}

export function dispatchSpeak(text) {
  if (!enabled || !("speechSynthesis" in window)) return;
  try {
    staticBurst(0.3, 0.06);
    beep(1500, 0.08);
    const u = new SpeechSynthesisUtterance(text);
    u.rate = 1.05;
    u.pitch = 0.85;
    u.volume = 0.9;
    const voices = window.speechSynthesis.getVoices();
    const en = voices.find((v) => v.lang?.startsWith("en"));
    if (en) u.voice = en;
    u.onend = () => { staticBurst(0.2, 0.04); };
    window.speechSynthesis.speak(u);
  } catch { /* audio is best-effort */ }
}
